import { render, staticRenderFns } from "./ProductScheme.vue?vue&type=template&id=0478df31&scoped=true&"
import script from "./ProductScheme.vue?vue&type=script&lang=js&"
export * from "./ProductScheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478df31",
  null
  
)

export default component.exports